import { ExtractPropTypes } from 'vue'
import type { SelectProps } from 'ant-design-vue/es/select'
// type SelectorTypes = keyof Reference.SelectorTypes

export const invoiceExpressCompanySelectProps = {
  apiParams: {
    type: Object,
    default: () => ({}),
  }
}

export type InvoiceExpressCompanySelectProps = Partial<ExtractPropTypes<typeof invoiceExpressCompanySelectProps>> & SelectProps